import { Can } from "@core/permissions";
import { Icon } from "@core/icons";
import { PortalButton } from "./PortalPrimitives";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el botón "Nuevo…" detrás de
// `Can module="content" action="canCreate"` se repetía palabra por palabra
// (en la barra de herramientas y de nuevo en el panel de "sin resultados")
// dentro de benefits/BenefitsScreen.tsx, rewards/RewardsScreen.tsx y
// offers/OffersScreen.tsx. Solo la etiqueta y el `onClick` difieren entre
// llamados. Extracción sin cambio de comportamiento ni de valores visuales:
// ninguna pantalla que la use cambia un pixel por esto.
export function CreateActionButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Can module="content" action="canCreate">
      <PortalButton size="small" onClick={onClick}>
        <Icon name="plus" size={15} /> {label}
      </PortalButton>
    </Can>
  );
}
